import * as React from 'react';
import { useRoutes } from 'react-router-dom';
import MainPage from '../pages/MainPage';
import LandingPage from '../pages/LandingPage';
import GrievanceStatusPage from '../pages/GrievanceStatusPage';

export default function Routes(){
    const routes = useRoutes([
        {path: '/', element: <LandingPage/>},
        {path: '/register-grievance', element: <MainPage/>},
        {path: '/grievance-status', element: <GrievanceStatusPage/>},
        // {path: '/ComplaintStatus-Review', element: <ComplaintStatusReview/>}
    ])
    return routes;
}